// This file is generated by scripts/generate-build-info.js.
const buildInfo = {
  "name": "Alfin Contacto",
  "version": "1.1.0",
  "buildDate": "2026-08-24T18:08:55.070Z"
};

export default buildInfo;
